export const currencies = {
    4: { iso3: 'EUR', id: 4, symbol: '€' },
    10: { iso3: 'USD', id: 10, symbol: '$' },
    21: { iso3: 'GBP', id: 21, symbol: '£' },
    2: { iso3: 'ZAR', id: 2, symbol: 'ZAR' },
    3: { iso3: 'NZD', id: 3, symbol: 'NZ$' },
    5: { iso3: 'THB', id: 5, symbol: 'Baht' },
    46: { iso3: 'INR', id: 46, symbol: 'Rs' },
    50: { iso3: 'SEK', id: 50, symbol: 'SEK' },
    51: { iso3: 'AUD', id: 51, symbol: 'AU$' },
    9: { iso3: 'JPY', id: 9, symbol: '¥' },
    48: { iso3: 'CNY', id: 48, symbol: 'RMB' },
    49: { iso3: 'BWP', id: 49, symbol: 'BWP' },
    42: { iso3: 'CAD', id: 42, symbol: 'CAD' },
    43: { iso3: 'BRL', id: 43, symbol: 'R$' },
    52: { iso3: 'NAD', id: 52, symbol: '$' },
    53: { iso3: 'HRK', id: 53, symbol: 'kn' },
    19: { iso3: 'AED', id: 19, symbol: 'AED' },
    55: { iso3: 'BGN', id: 55, symbol: 'лв' },
    56: { iso3: 'CHF', id: 56, symbol: 'CHF' },
    29: { iso3: 'CZK', id: 29, symbol: 'Kč' },
    57: { iso3: 'DKK', id: 57, symbol: 'DKK' },
    34: { iso3: 'HKD', id: 34, symbol: 'HK$' },
    26: { iso3: 'HUF', id: 26, symbol: 'Ft' },
    30: { iso3: 'ILS', id: 30, symbol: 'ILS' },
    58: { iso3: 'MXN', id: 58, symbol: 'MXN' },
    54: { iso3: 'NOK', id: 54, symbol: 'NOK' },
    59: { iso3: 'PLN', id: 59, symbol: 'PLN' },
    60: { iso3: 'QAR', id: 60, symbol: 'QAR' },
    61: { iso3: 'RON', id: 61, symbol: 'RON' },
    62: { iso3: 'SAR', id: 62, symbol: 'SAR' },
    25: { iso3: 'SGD', id: 25, symbol: 'S$' },
    63: { iso3: 'TRY', id: 63, symbol: 'TRY' },
};

export const currenciesByMarket = {
    FR: [
        { iso3: 'EUR', subunit: 2 },
        { iso3: 'CAD', subunit: 2 },
        { iso3: 'CHF', subunit: 2 },
    ],
    ES: [{ iso3: 'EUR', subunit: 2 }],
    IT: [
        { iso3: 'EUR', subunit: 2 },
        { iso3: 'CHF', subunit: 2 },
    ],
    GB: [
        { iso3: 'GBP', subunit: 2 },
        { iso3: 'USD', subunit: 2 },
        { iso3: 'CAD', subunit: 2 },
        { iso3: 'EUR', subunit: 2 },
    ],
    DE: [
        { iso3: 'EUR', subunit: 2 },
        { iso3: 'CHF', subunit: 2 },
    ],
    SE: [
        { iso3: 'SEK', subunit: 2 },
        { iso3: 'EUR', subunit: 2 },
        { iso3: 'USD', subunit: 2 },
    ],
    DK: [
        { iso3: 'DKK', subunit: 2 },
        { iso3: 'USD', subunit: 2 },
        { iso3: 'EUR', subunit: 2 },
    ],
    NL: [{ iso3: 'EUR', subunit: 2 }],
    CH: [
        { iso3: 'CHF', subunit: 2 },
        { iso3: 'EUR', subunit: 2 },
    ],
    AT: [{ iso3: 'EUR', subunit: 2 }],
    CA: [
        { iso3: 'CAD', subunit: 2 },
        { iso3: 'USD', subunit: 2 },
    ],
    US: [{ iso3: 'USD', subunit: 2 }],
};

export const currencySubunit = 100;

export const NB_DAYS_PAYMENT_BALANCE_DATES_SHIFT = -45;
